<template>
	<div id="order_list" class="all_app p_background clearfix">
		<h3 class="all_title">订单管理</h3>
		<section class="all_container container_box">

			<div class="operation_box clearfix">
				<section class="date pull-left">
					<el-date-picker 
						v-model="dateScop" 
						type="daterange"
						range-separator="-"
						@change="searchDaterange" 
						format="yyyy-MM-dd" 
						value-format="yyyy-MM-dd"
						start-placeholder="开始时间" 
						end-placeholder="结束时间">
					</el-date-picker>
					</el-date-picker>
				</section>
				<section class="date_sort pull-left" @click="dateSort">
					<span>时间</span>
					<i class="glyphicon icon icon_down1"></i>
				</section>
				<section class="money_sort pull-left" @click="moneySort">
					金额
					<i class="glyphicon icon icon_down"></i>
				</section>
				<section class="look_type pull-left">
					<select class="select" v-model="appType" @change="queryTCloudAppOrderList">
						<option value="">查看全部类型</option>
						<option value="2">只看区级</option>
						<option value="1">只看校级</option>
						<option value="free">只看免费试用</option>
					</select>
				</section>
				<section class="account_type pull-left">
					<select class="select" v-model="orderStatus" @change="queryTCloudAppOrderList">
						<option value="">查看到账情况</option>
						<option value="113002">已到账</option>
						<option value="113001">未到账</option>
					</select>
				</section>
				<div class="pull-right">
					<section class="search_box border_color">
						<input type="text" class="search_control" placeholder="输入应用名称或订单编号" v-model.trim="appNameOrderNo" @keyup.enter="queryTCloudAppOrderList"/>
						<i class="glyphicon icon_search" @click="queryTCloudAppOrderList"></i>
					</section>
				</div>
			</div>

			<!--table start-->
			<div class="table_box clearfix">
				<table class="table table-hover text-center">
					<thead>
						<tr>
							<th>订单编号</th>
							<th>应用名称</th>
							<th>版本编号</th>
							
							<th>购买者</th>
							<th>购买时间</th>
							<th>金额及类型</th>
							<th>是否到账及类型</th>
							<th>授权状态</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="(item,index) in page.content">
							<td>
								{{item.orderNo}}
							</td>
							<td class="line_block text-left">
								<div class="apply_thumbnail">
									<img class="img_default" :src="item.filePath" alt="" />
								</div>
								<div class="text-left">
									<p>{{item.viewName}}</p>
								</div>
							</td>
							
							<td>
								<p>{{item.versionNo}}</p>
							</td>
							
							<td>
								<p>{{item.chName}}</p>
								<p class="color_9" v-if="item.appLevel == 1 && item.userType == 101010">区级购买（{{item.nums}}套）</p>
							</td>
							<td>
								{{item.orderTime | time}}
							</td>
							<td v-if="item.orderStatus != 114001">
								<p>
									{{item.orderPrice}}元人民币
								</p>
								<p v-if="item.onecoverTime == 9999">
									无期限
								</p>
								<p v-if="item.durationOneset%12 == 0">
									{{item.durationOneset/12}}年期限
									
								</p>
								<p v-if="item.durationOneset%12 > 0">
									<span v-if="item.durationOneset/12 >= 1">{{item.durationOneset/12 | fmtMoney}}年</span>
									{{item.durationOneset%12}}个月期限
								</p>
							</td>
							<td v-else>
								<p>
									免费试用（一个月）
								</p>
							</td>
							<td v-if="item.orderStatus != '114001'">
								<p v-if="item.payStatus == '113002'">
									已到账
								</p>
								<p v-else>
									未到账
								</p>
								
								<div class="margin_b4" v-if="item.payStatus != '113002'">
									<button class="btn btn_border" id="confirm_order" @click="confirmOrder(item.id)">确认到账</button>
								</div>
							</td>
							<td v-else>
								<p>
									实时开通
								</p>
							</td>
							<td v-if="item.orderStatus != '114001'">
								<p v-if="item.orderStatus == '114005' || item.orderStatus == '114006'">
									已授权使用
								</p>
								<p v-else>
									未授权使用
								</p>
								<!--<div class="margin_b4" v-if="item.status == 112001">
									<button class="btn btn_border" id="authorized_use" @click="toAuthUse(item.id)">授权使用</button>
								</div>
								<div class="margin_b4" v-if="item.status == 112002 && item.payStatus == 0">
									<button class="btn btn_border" id="authorized_use" @click="disableAuthUse(item.id)">解除授权</button>
								</div>-->
								
							</td>
							<td v-else-if="item.orderStatus == '114001'">
								<p>剩余{{item.diffDays}}</p>
							</td>
						</tr>
						<tr v-if="page.total <=0 ">
							<td colspan="8">暂无数据</td>
						</tr>
					</tbody>
				</table>
			</div>
			<!--table end-->
			<div class="text-center" v-bind:class="page.totalPages &gt; 0 ? 'show' : 'hidden'">
				<div class="row-fluid">
					<el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              :page-sizes="[10, 20, 30, 40]"
              :page-size="pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="page.total">
          </el-pagination>
				</div>
			</div>
			<!--模态弹出-->
			<v-tip :trueFlag="trueFlag" :falseFlag="falseFlag" :tipMsg="tipMsg"></v-tip>

			<!--confirm-->
			<v-confirm v-if="confirmFlag" :bigMsg="bigMsg" @confirmOff="confirmFlag = !confirmFlag" @confirmTrue=""></v-confirm>
		</section>
		</section>
	</div>
</template>

<script>
	import { MessageBox } from 'element-ui'
	export default {
		data() {
			return {
				appNameOrderNo: '',
				startTime: '',
				endTime: '',
				trueFlag: false,
				falseFlag: false,
				tipMsg: '',
				confirmFlag: false,
				bigMsg: '',
				dateScop: '',
				listSize: 0,
				appOrderList: '',
				currentPage:1,
	      pageSize:10,
	      page:'',
				dateSortt: 0,
				moneySortt: '',
				appType: '',//适用类型
				orderStatus: '',//到账情况
			}
		},
		created: function() {
			//查询订单列
			this.queryTCloudAppOrderList();
		},
		mounted: function() {
			this.$nextTick(function() {
				
				$(".date_sort,.money_sort").click(function(){
					var i = $(this).find(".icon");
					$(this).siblings().find(".icon").removeClass("icon_up").removeClass("icon_down1").addClass("icon_down");
					if(i.hasClass("icon_down1")){
						i.removeClass("icon_down1").addClass("icon_up");
					}else if(i.hasClass("icon_down")){
						i.addClass("icon_down1").removeClass("icon_down");
					}else if(i.hasClass("icon_up")){
						i.removeClass("icon_up").addClass("icon_down1");
					}
				})
			})
		},
		methods: {
			handleSizeChange(val) {
        	this.pageSize = val;
        	this.currentPage = 1;
          var temp = this;
          this.$http.post('/zklccloud/findTCloudAppOrderListDeveloper',{"dateSort":this.dateSortt,"moneySort":this.moneySortt,"startTime": temp.startTime, "endTime": temp.endTime,"appLevel": this.appType, "payStatus": this.orderStatus,"condition": this.appNameOrderNo,"page": this.currentPage - 1,"size":this.pageSize},{emulateJSON:true}).then(function(m){
	      	temp.page = m.data.content.pageList
		    })
        },
        handleCurrentChange(val) {
        	this.currentPage = val;
          var temp = this;
          this.$http.post('/zklccloud/findTCloudAppOrderListDeveloper',{"dateSort":this.dateSortt,"moneySort":this.moneySortt,"startTime": temp.startTime, "endTime": temp.endTime,"appLevel": this.appType, "payStatus": this.orderStatus,"condition": this.appNameOrderNo,"page": val - 1,"size":this.pageSize},{emulateJSON:true}).then(function(m){
	      	temp.page = m.data.content.pageList
		    })
       },
			queryTCloudAppOrderList(){
				this.currentPage = 1;
				var temp = this;
				this.$http.post('/zklccloud/findTCloudAppOrderListDeveloper', {"dateSort":this.dateSortt,"moneySort":this.moneySortt,"startTime": temp.startTime, "endTime": temp.endTime,"appLevel": this.appType, "payStatus": this.orderStatus,"condition": this.appNameOrderNo,"page": this.currentPage - 1,"size":this.pageSize},{ emulateJSON: true }).then(function(m) {
					temp.page = m.data.content.pageList
				})
			},
			//确认到账
			confirmOrder(id){
				var temp = this;
				this.$http.post('/zklccloud/setTCloudAppPayStatus', {"id": id}, { emulateJSON: true }).then(function(m) {
					if(m.body.resultCode == '0'){
						MessageBox('操作成功！', '提示', 'success', {
							confirmButtonText: '确定',
						}).then(() => {
							temp.queryTCloudAppOrderList();
						})
					}
				})
			},
			//授权应用
			toAuthUse(id){
				var temp = this;
				this.$http.post('/zklccloud/setTCloudAppAuthorization', {"id": id}, { emulateJSON: true }).then(function(m) {
					if(m.body.resultCode == '0'){
						MessageBox('操作成功！', '提示', 'success', {
							confirmButtonText: '确定',
						}).then(() => {
							temp.queryTCloudAppOrderList();
						})
					}
				})
			},
			//解除授权
			disableAuthUse(id){
				var temp = this;
				this.$http.post('/zklccloud/disableTCloudAppAuthorization', {"id": id}, { emulateJSON: true }).then(function(m) {
					if(m.body.resultCode == '0'){
						MessageBox('操作成功！', '提示', 'success', {
							confirmButtonText: '确定',
						}).then(() => {
							temp.queryTCloudAppOrderList();
						})
					}
				})
			},
			dateSort(){
				this.moneySortt='';
				if(this.dateSortt === 0){
					this.dateSortt = 1;
				}else if(this.dateSortt === 1){
					this.dateSortt = 0;
				}else{
					this.dateSortt = 0;
				}
				this.queryTCloudAppOrderList();
			},
			moneySort(){
				this.dateSortt = '';
				if(this.moneySortt === 0){
					this.moneySortt = 1;
				}else if(this.moneySortt === 1){
					this.moneySortt = 0;
				}else{
					this.moneySortt = 0;
				}
				this.queryTCloudAppOrderList();
			},
			searchDaterange(data) {
				var temp = this;
				if(!!data) {
					data = data.toString();
					temp.startTime = data.split(",")[0];
					temp.endTime = data.split(",")[1];
				}else{
					temp.startTime = "";
					temp.endTime = "";
				}
				if(typeof(temp.startTime) == "undefined") {
					temp.startTime = "";
				}
				if(typeof(temp.endTime) == "undefined") {
					temp.endTime = "";
				}
				
				this.queryTCloudAppOrderList();
			}
		}
	}
</script>

<style scoped>
	.operation_box {
		margin-bottom: 15px;
	}
	
	.operation_box>section {
		border-right: 1px solid #eee;
		border-top: 1px solid #eee;
		border-bottom: 1px solid #eee;
		height: 30px;
		line-height: 30px;
		padding: 0 13px;
		cursor: pointer;
		color: #666;
	}
	
	.operation_box>section:first-child {
		border-left: 1px solid #eee!important;
	}
	
	.icon_down {
		width: 20px;
		height: 20px;
		background: url(./img/icon-down.png) no-repeat center center;
		-webkit-background-size: 18px;
		background-size: 18px;
		vertical-align: sub;
	}
	
	.icon_down1 {
		width: 20px;
		height: 20px;
		background: url(./img/icon-down-h.png) no-repeat center center;
		-webkit-background-size: 18px;
		background-size: 18px;
		vertical-align: sub;
	}
	
	.icon_up {
		width: 20px;
		height: 20px;
		background: url(./img/icon-up-h.png) no-repeat center center;
		-webkit-background-size: 18px;
		background-size: 18px;
		vertical-align: sub;
	}
	
	.operation_box>section:hover .icon_down {
		background: url(./img/icon-down-h.png) no-repeat center center;
		-webkit-background-size: 18px;
		background-size: 18px;
	}
	
	.select {
		border: 0 none;
		display: block;
		height: 28px;
	}
	
	.select {
		-webkit-appearance: none;
		-moz-appearance: none;
		-ms-appearance: none;
		appearance: none;
		border: 0 none;
		width: auto;
		background-color: #fff;
		padding: 0;
		color: #666;
		-webkit-transition: transform .2s;
		-moz-transition: transform .2s;
		-ms-transition: transform .2s;
		-o-transition: transform .2s;
		transition: transform .2s;
		background: url(./img/icon-arrow-down.png) no-repeat right center;
		-webkit-background-size: 18px;
		background-size: 18px;
		padding-right: 26px;
	}
	
	.select:focus {
		outline: none;
	}
	
	.select::-ms-expand {
		display: none;
	}
	
	.select::-ms-value {
		color: #666;
	}
	
	.operation_box .search_control {
		width: 200px;
	}
	
	.table_box p {
		margin-bottom: 4px;
	}
	
	.table {
		color: #252a3d;
	}
	.border_color {
		border-color: #DBDBDB;
	}
	
	.icon_cheque {
		position: relative;
		width: 20px;
		height: 14px;
		background: url(../../assets/images/icon-cheque.png) no-repeat center center;
		-webkit-background-size: 20px;
		background-size: 20px;
		margin-left: 6px;
	}
	
	.icon_cheque:hover > span {
		display: block;
	}
	
	.icon_cheque > span {
		display: none;
		position: absolute;
		top: 14px;
		left: 0;
		min-width: 188px;
		padding: 8px 6px;
		border: 1px solid #FE7C1C;
		background-color: #fff;
		color: #3e4046;
		z-index: 999;
	}
	
	.icon_cheque > span small {
		display: block;
		text-align: left;
		margin-bottom: 5px;
	}
</style>
<style type="text/css">
	#order_list .date .el-input__inner {
		border: 0 none;
		width: 230px;
		height: 28px;
		padding-top: 0;
		padding-bottom: 0;
	}
	
	#order_list .date .el-input {
		display: block;
		color: #666;
	}
</style>


// WEBPACK FOOTER //
// list.vue?216038d7